'use strict';

var styled = require('styled-components');
var styles = require('../Heading/styles.js');
var styles$1 = require('../Text/styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const TooltipContainer = styled__default.default.div `
  display: ${({ isOpened }) => (isOpened ? 'block' : 'none')};
  padding: ${({ theme, placement }) => placement.startsWith('bottom') || placement.startsWith('top') ? theme.designTokens.tooltipOffsetY : '0'}
    ${({ theme, placement }) => placement.startsWith('left') || placement.startsWith('right') ? theme.designTokens.tooltipOffsetX : '0'};
  background: transparent;
  z-index: ${({ theme }) => theme.designTokens.tooltipZIndex};
`;
const Tooltip = styled__default.default.div `
  padding: ${({ theme }) => theme.designTokens.tooltipPaddingY} ${({ theme }) => theme.designTokens.tooltipPaddingX};
  background: ${({ theme }) => theme.designTokens.tooltipBackgroundColor};
  border-radius: ${({ theme }) => theme.designTokens.tooltipRadius};

  /* stylelint-disable */
  &,
  & ${styles.Styled.Div}, & ${styles$1.Styled.Span} {
    color: ${({ theme }) => theme.designTokens.tooltipTextColor};
  }
  /* stylelint-enable */

  & a {
    color: ${({ theme }) => theme.designTokens.tooltipTextColor};
  }
`;
const Styled = {
    Tooltip,
    TooltipContainer,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
